'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSetting = exports.fetchSettings = undefined;

var _memoize = require('../utilities/memoize');

var _memoize2 = _interopRequireDefault(_memoize);

var _apiClient = require('hub-http/clients/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var portalId = _hubspot2.default.get();
var url = 'hubs/v1/hubs/' + portalId + '/settings';

var fetchSettings = exports.fetchSettings = (0, _memoize2.default)(function () {
  return _apiClient2.default.get(url);
});

var setSetting = exports.setSetting = function setSetting(key, value) {
  return _apiClient2.default.post(url, {
    data: {
      hubId: portalId,
      internal: false,
      key: key,
      value: value
    }
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.837/js/core/api/settingsApi.js
// module id = 617
// module chunks = 3 4